var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('country-field',_vm._b({attrs:{"hide-details":"auto","item-text":"name"},on:{"input":_vm.setCountryCode},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}},'country-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }